var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v("\n        Add Investment Component\n    ")]),_c('footer',[_c('popup-bottom-container',[_c('template',{slot:"end"},[_c('btn-grp',{staticClass:"form-button"},[_c('btn',{attrs:{"text":"Back","type":"secondary"}}),_c('btn',{attrs:{"text":"Add","type":"primary"},on:{"click":_vm.addInvestment}})],1)],1)],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }